"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("utils/upload/actions");
var actions = (0, actions_1.createActions)('@sok/web/bid/question/answerFile');
exports.default = actions;
